import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Card, space, color } from '@ticketswap/solar'
import ListingAvatar from '~/components/ListingAvatar'
import ListingAvatarBadge from '~/components/ListingAvatarBadge'
import { externalPrimaryTicketShopFragmentPropTypes } from '~/graphql/fragments/externalPrimaryTicketShop'

const StyledCard = styled(Card)`
  margin: ${space[8]} 0;
  cursor: pointer;

  h4 + span {
    color: ${props => (props.state === 'SOLD_OUT' ? color.mars : color.spaceMedium)};
  }
`

const AvatarContainer = styled.div`
  position: relative;
`

const ExternalPrimaryTicketShopOffering = ({ externalPrimaryTicketShop, t, ...props }) => {
  const { state, shopImageUrl, shopUrl } = externalPrimaryTicketShop
  const { url: imageUrl = 'https://placehold.it/50x50' } = shopImageUrl || {}
  const { host: ticketShopPath, url } = shopUrl

  const handleOnClick = () => (window.location.href = url)

  return (
    <a onClick={handleOnClick} {...props}>
      <StyledCard
        state={state}
        size="large"
        verticalAlign="top"
        title={t('event-eventtype:externalPrimaryTicketShop.title')}
        text={
          state === 'SOLD_OUT'
            ? t('event-eventtype:externalPrimaryTicketShop.soldOut')
            : ticketShopPath
        }
        leftAdornment={
          <AvatarContainer>
            <ListingAvatar image={imageUrl} />
            <ListingAvatarBadge />
          </AvatarContainer>
        }
      />
    </a>
  )
}

ExternalPrimaryTicketShopOffering.propTypes = {
  t: PropTypes.func.isRequired,
  externalPrimaryTicketShop: externalPrimaryTicketShopFragmentPropTypes,
}

export default ExternalPrimaryTicketShopOffering
